import { render, staticRenderFns } from "./base-tag.vue?vue&type=template&id=0693f0ca&scoped=true"
import script from "./base-tag.vue?vue&type=script&setup=true&lang=js"
export * from "./base-tag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-tag.vue?vue&type=style&index=0&id=0693f0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0693f0ca",
  null
  
)

export default component.exports